<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="alsohead"><a id="pageii"></a><a href="#/OEBPS/toc.htm#also">Also by Mark Bowden</a></p>
<p class="also"><em>Hue 1968</em></p>
<p class="also"><em>Doctor Dealer</em></p>
<p class="also"><em>Bringing the Heat</em></p>
<p class="also"><em>Black Hawk Down</em></p>
<p class="also"><em>Finders Keepers</em></p>
<p class="also"><em>Road Work</em></p>
<p class="also"><em>Guests of the Ayatollah</em></p>
<p class="also"><em>The Best Game Ever</em></p>
<p class="also"><em>Worm</em></p>
<p class="also"><em>The Finish</em></p>
<p class="also"><em>The Three Battles of Wanat</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?1f37600e